// extracted by mini-css-extract-plugin
export default {"MainContent":"Content_MainContent__T57bC","pageDescription":"Content_pageDescription__lDqrz"};